import React, {useState} from "react";
import {Button, CircularProgress, Dialog, DialogActions, DialogContent} from "@mui/material";
import {ClosableDialogTitle} from "@atttomyx/react-components";
import {TaskForm} from "../forms";
import {taskService} from "../../services";
import {datetime, forms} from "@atttomyx/shared-utils";
import {TASK_TYPE} from "../../constants";

const toData = (task) => {
    const local = task.dueAt ? datetime.isoToLocalDateTime(task.dueAt) : null;
    const date = local
        ? datetime.getDate(local)
        : task.dueOn ? task.dueOn : datetime.today();
    const time = local ? datetime.getTime(local) : null;

    return {
        title: task.title,
        description: task.description,
        date: date,
        time: time,
        valid: false,
    }
};

const TaskDialog = (props) => {
    const {snackbar, task, onCancel, onSave} = props;
    const [data, setData] = useState(toData(task));
    const [saving, setSaving] = useState(false);

    const submitForm = () => {
        const success = (saved) => {
            snackbar.setSuccess("Event saved");
            setSaving(false);
            onSave(saved);
        };

        const failure = (err) => {
            snackbar.setError(err);
            setSaving(false);
            onCancel();
        };

        let dueOn = null;
        let dueAt = null;

        if (data.time) {
            dueAt = datetime.localDateTimeToIso(`${data.date}T${data.time}`);

        } else {
            dueOn = data.date;
        }

        const modified = {
            title: data.title,
            description: data.description,
            dueOn: dueOn,
            dueAt: dueAt,
            type: TASK_TYPE,
            metadata: task.metadata,
        };

        setSaving(true);

        if (task.id) {
            taskService.updateTask(task.id, modified, success, failure);

        } else {
            taskService.createTask(modified, success, failure);
        }
    };

    return <Dialog
        open={true}
        aria-labelledby="task-dialog"
    >
        <ClosableDialogTitle onClose={onCancel}>
            {task.id ? "Edit" : "Add"} Event
        </ClosableDialogTitle>
        <DialogContent className="task">
            {saving ?
                <CircularProgress size="40px"/> :
                <TaskForm
                    data={data}
                    onChange={setData}
                />}
        </DialogContent>
        <DialogActions>
            {!saving ?
                <Button
                    color="primary"
                    disabled={!data.valid || !forms.differ(toData(task), data)}
                    onClick={submitForm}
                >
                    Save
                </Button> : null}
        </DialogActions>
    </Dialog>
}

export default TaskDialog;
